export function data() {
  return {
    plaid: null,
    linkHandler: null
  }
}
